export default __webpack_public_path__ + "static/media/Index_Page_Thumbnail.c8f3cdc8.png";